import { render } from "./AlreadyUsedMaterialSelector.vue?vue&type=template&id=52642662"
import script from "./AlreadyUsedMaterialSelector.vue?vue&type=script&lang=js"
export * from "./AlreadyUsedMaterialSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__